// Auto-generated from upload_logos.py
export interface TeamInfo {
    name: string;
    logo_id: string;
}

export const TEAM_MAPPINGS: Record<string, TeamInfo> = {
    "Abilene Christian": {
        name: "Abilene Christian",
        logo_id: "2000",
    },
    "Air Force": {
        name: "Air Force",
        logo_id: "2005",
    },
    "Akron": {
        name: "Akron",
        logo_id: "2006",
    },
    "Alabama": {
        name: "Alabama",
        logo_id: "333",
    },
    "Alabama A&M": {
        name: "Alabama A&M",
        logo_id: "2010",
    },
    "Alabama State": {
        name: "Alabama State",
        logo_id: "2011",
    },
    "Albany": {
        name: "Albany",
        logo_id: "399",
    },
    "Alcorn State": {
        name: "Alcorn State",
        logo_id: "2016",
    },
    "American University": {
        name: "American University",
        logo_id: "44",
    },
    "Appalachian State": {
        name: "Appalachian State",
        logo_id: "2026",
    },
    "Arizona": {
        name: "Arizona",
        logo_id: "12",
    },
    "Arizona State": {
        name: "Arizona State",
        logo_id: "9",
    },
    "Arkansas": {
        name: "Arkansas",
        logo_id: "8",
    },
    "Arkansas State": {
        name: "Arkansas State",
        logo_id: "2032",
    },
    "Arkansas-Pine Bluff": {
        name: "Arkansas-Pine Bluff",
        logo_id: "2029",
    },
    "Army": {
        name: "Army",
        logo_id: "349",
    },
    "Auburn": {
        name: "Auburn",
        logo_id: "2",
    },
    "Austin Peay": {
        name: "Austin Peay",
        logo_id: "2046",
    },
    "BYU": {
        name: "BYU",
        logo_id: "252",
    },
    "Ball State": {
        name: "Ball State",
        logo_id: "2050",
    },
    "Baylor": {
        name: "Baylor",
        logo_id: "239",
    },
    "Bellarmine": {
        name: "Bellarmine",
        logo_id: "91",
    },
    "Belmont": {
        name: "Belmont",
        logo_id: "2057",
    },
    "Bethune-Cookman": {
        name: "Bethune-Cookman",
        logo_id: "2065",
    },
    "Binghamton": {
        name: "Binghamton",
        logo_id: "2066",
    },
    "Boise State": {
        name: "Boise State",
        logo_id: "68",
    },
    "Boston College": {
        name: "Boston College",
        logo_id: "103",
    },
    "Boston University": {
        name: "Boston University",
        logo_id: "104",
    },
    "Bowling Green": {
        name: "Bowling Green",
        logo_id: "189",
    },
    "Bradley": {
        name: "Bradley",
        logo_id: "71",
    },
    "Brown": {
        name: "Brown",
        logo_id: "225",
    },
    "Bryant": {
        name: "Bryant",
        logo_id: "2803",
    },
    "Bucknell": {
        name: "Bucknell",
        logo_id: "2083",
    },
    "Buffalo": {
        name: "Buffalo",
        logo_id: "2084",
    },
    "Butler": {
        name: "Butler",
        logo_id: "2086",
    },
    "CSU Bakersfield": {
        name: "CSU Bakersfield",
        logo_id: "2934",
    },
    "CSU Fullerton": {
        name: "CSU Fullerton",
        logo_id: "2239",
    },
    "CSU Northridge": {
        name: "CSU Northridge",
        logo_id: "2463",
    },
    "Cal Poly": {
        name: "Cal Poly",
        logo_id: "13",
    },
    "California": {
        name: "California",
        logo_id: "25",
    },
    "California Baptist": {
        name: "California Baptist",
        logo_id: "2856",
    },
    "Campbell": {
        name: "Campbell",
        logo_id: "2097",
    },
    "Canisius": {
        name: "Canisius",
        logo_id: "2099",
    },
    "Central Arkansas": {
        name: "Central Arkansas",
        logo_id: "2110",
    },
    "Central Connecticut": {
        name: "Central Connecticut",
        logo_id: "2115",
    },
    "Central Michigan": {
        name: "Central Michigan",
        logo_id: "2117",
    },
    "Charleston": {
        name: "Charleston",
        logo_id: "232",
    },
    "Charleston Southern": {
        name: "Charleston Southern",
        logo_id: "2127",
    },
    "Charlotte": {
        name: "Charlotte",
        logo_id: "2429",
    },
    "Chattanooga": {
        name: "Chattanooga",
        logo_id: "236",
    },
    "Chicago State": {
        name: "Chicago State",
        logo_id: "2130",
    },
    "Cincinnati": {
        name: "Cincinnati",
        logo_id: "2132",
    },
    "Clemson": {
        name: "Clemson",
        logo_id: "228",
    },
    "Cleveland State": {
        name: "Cleveland State",
        logo_id: "325",
    },
    "Coastal Carolina": {
        name: "Coastal Carolina",
        logo_id: "324",
    },
    "Colgate": {
        name: "Colgate",
        logo_id: "2142",
    },
    "Colorado": {
        name: "Colorado",
        logo_id: "38",
    },
    "Colorado State": {
        name: "Colorado State",
        logo_id: "36",
    },
    "Columbia": {
        name: "Columbia",
        logo_id: "171",
    },
    "Coppin State": {
        name: "Coppin State",
        logo_id: "2154",
    },
    "Cornell": {
        name: "Cornell",
        logo_id: "172",
    },
    "Creighton": {
        name: "Creighton",
        logo_id: "156",
    },
    "Dartmouth": {
        name: "Dartmouth",
        logo_id: "159",
    },
    "Davidson": {
        name: "Davidson",
        logo_id: "2166",
    },
    "Dayton": {
        name: "Dayton",
        logo_id: "2168",
    },
    "DePaul": {
        name: "DePaul",
        logo_id: "305",
    },
    "Delaware": {
        name: "Delaware",
        logo_id: "48",
    },
    "Delaware State": {
        name: "Delaware State",
        logo_id: "2169",
    },
    "Denver": {
        name: "Denver",
        logo_id: "2172",
    },
    "Detroit Mercy": {
        name: "Detroit Mercy",
        logo_id: "2174",
    },
    "Dixie State": {
        name: "Dixie State",
        logo_id: "3101",
    },
    "Drake": {
        name: "Drake",
        logo_id: "2181",
    },
    "Drexel": {
        name: "Drexel",
        logo_id: "2182",
    },
    "Duke": {
        name: "Duke",
        logo_id: "150",
    },
    "Duquesne": {
        name: "Duquesne",
        logo_id: "2184",
    },
    "East Carolina": {
        name: "East Carolina",
        logo_id: "151",
    },
    "East Tennessee State": {
        name: "East Tennessee State",
        logo_id: "2193",
    },
    "Eastern Illinois": {
        name: "Eastern Illinois",
        logo_id: "2197",
    },
    "Eastern Kentucky": {
        name: "Eastern Kentucky",
        logo_id: "2198",
    },
    "Eastern Michigan": {
        name: "Eastern Michigan",
        logo_id: "2199",
    },
    "Eastern Washington": {
        name: "Eastern Washington",
        logo_id: "331",
    },
    "Elon": {
        name: "Elon",
        logo_id: "2210",
    },
    "Evansville": {
        name: "Evansville",
        logo_id: "339",
    },
    "Fairfield": {
        name: "Fairfield",
        logo_id: "2217",
    },
    "Fairleigh Dickinson": {
        name: "Fairleigh Dickinson",
        logo_id: "161",
    },
    "Florida": {
        name: "Florida",
        logo_id: "57",
    },
    "Florida A&M": {
        name: "Florida A&M",
        logo_id: "50",
    },
    "Florida Atlantic": {
        name: "Florida Atlantic",
        logo_id: "2226",
    },
    "Florida Gulf Coast": {
        name: "Florida Gulf Coast",
        logo_id: "526",
    },
    "Florida International": {
        name: "Florida International",
        logo_id: "2229",
    },
    "Florida State": {
        name: "Florida State",
        logo_id: "52",
    },
    "Fordham": {
        name: "Fordham",
        logo_id: "2230",
    },
    "Fresno State": {
        name: "Fresno State",
        logo_id: "278",
    },
    "Furman": {
        name: "Furman",
        logo_id: "231",
    },
    "Gardner-Webb": {
        name: "Gardner-Webb",
        logo_id: "2241",
    },
    "George Mason": {
        name: "George Mason",
        logo_id: "2244",
    },
    "George Washington": {
        name: "George Washington",
        logo_id: "45",
    },
    "Georgetown": {
        name: "Georgetown",
        logo_id: "46",
    },
    "Georgia": {
        name: "Georgia",
        logo_id: "61",
    },
    "Georgia Southern": {
        name: "Georgia Southern",
        logo_id: "290",
    },
    "Georgia State": {
        name: "Georgia State",
        logo_id: "2247",
    },
    "Georgia Tech": {
        name: "Georgia Tech",
        logo_id: "59",
    },
    "Gonzaga": {
        name: "Gonzaga",
        logo_id: "2250",
    },
    "Grambling": {
        name: "Grambling",
        logo_id: "2755",
    },
    "Grand Canyon": {
        name: "Grand Canyon",
        logo_id: "2253",
    },
    "Green Bay": {
        name: "Green Bay",
        logo_id: "2739",
    },
    "Hampton": {
        name: "Hampton",
        logo_id: "2261",
    },
    "Hartford": {
        name: "Hartford",
        logo_id: "42",
    },
    "Harvard": {
        name: "Harvard",
        logo_id: "108",
    },
    "Hawai'i": {
        name: "Hawai'i",
        logo_id: "62",
    },
    "High Point": {
        name: "High Point",
        logo_id: "2272",
    },
    "Hofstra": {
        name: "Hofstra",
        logo_id: "2275",
    },
    "Holy Cross": {
        name: "Holy Cross",
        logo_id: "107",
    },
    "Houston": {
        name: "Houston",
        logo_id: "248",
    },
    "Houston Baptist": {
        name: "Houston Baptist",
        logo_id: "2277",
    },
    "Howard": {
        name: "Howard",
        logo_id: "47",
    },
    "IUPUI": {
        name: "IUPUI",
        logo_id: "85",
    },
    "Idaho": {
        name: "Idaho",
        logo_id: "70",
    },
    "Idaho State": {
        name: "Idaho State",
        logo_id: "304",
    },
    "Illinois": {
        name: "Illinois",
        logo_id: "356",
    },
    "Illinois State": {
        name: "Illinois State",
        logo_id: "2287",
    },
    "Incarnate Word": {
        name: "Incarnate Word",
        logo_id: "2916",
    },
    "Indiana": {
        name: "Indiana",
        logo_id: "84",
    },
    "Indiana State": {
        name: "Indiana State",
        logo_id: "282",
    },
    "Iona": {
        name: "Iona",
        logo_id: "314",
    },
    "Iowa": {
        name: "Iowa",
        logo_id: "2294",
    },
    "Iowa State": {
        name: "Iowa State",
        logo_id: "66",
    },
    "Jackson State": {
        name: "Jackson State",
        logo_id: "2296",
    },
    "Jacksonville": {
        name: "Jacksonville",
        logo_id: "294",
    },
    "Jacksonville State": {
        name: "Jacksonville State",
        logo_id: "55",
    },
    "James Madison": {
        name: "James Madison",
        logo_id: "256",
    },
    "Kansas": {
        name: "Kansas",
        logo_id: "2305",
    },
    "Kansas City": {
        name: "Kansas City",
        logo_id: "140",
    },
    "Kansas State": {
        name: "Kansas State",
        logo_id: "2306",
    },
    "Kennesaw State": {
        name: "Kennesaw State",
        logo_id: "338",
    },
    "Kent State": {
        name: "Kent State",
        logo_id: "2309",
    },
    "Kentucky": {
        name: "Kentucky",
        logo_id: "96",
    },
    "LSU": {
        name: "LSU",
        logo_id: "99",
    },
    "La Salle": {
        name: "La Salle",
        logo_id: "2325",
    },
    "Lafayette": {
        name: "Lafayette",
        logo_id: "322",
    },
    "Lamar": {
        name: "Lamar",
        logo_id: "2320",
    },
    "Lehigh": {
        name: "Lehigh",
        logo_id: "2329",
    },
    "Liberty": {
        name: "Liberty",
        logo_id: "2335",
    },
    "Lipscomb": {
        name: "Lipscomb",
        logo_id: "288",
    },
    "Little Rock": {
        name: "Little Rock",
        logo_id: "2031",
    },
    "Long Beach State": {
        name: "Long Beach State",
        logo_id: "299",
    },
    "Long Island University": {
        name: "Long Island University",
        logo_id: "112358",
    },
    "Longwood": {
        name: "Longwood",
        logo_id: "2344",
    },
    "Louisiana": {
        name: "Louisiana",
        logo_id: "309",
    },
    "Louisiana Tech": {
        name: "Louisiana Tech",
        logo_id: "2348",
    },
    "Louisville": {
        name: "Louisville",
        logo_id: "97",
    },
    "Loyola (MD)": {
        name: "Loyola (MD)",
        logo_id: "2352",
    },
    "Loyola Chicago": {
        name: "Loyola Chicago",
        logo_id: "2350",
    },
    "Loyola Marymount": {
        name: "Loyola Marymount",
        logo_id: "2351",
    },
    "Maine": {
        name: "Maine",
        logo_id: "311",
    },
    "Manhattan": {
        name: "Manhattan",
        logo_id: "2363",
    },
    "Marist": {
        name: "Marist",
        logo_id: "2368",
    },
    "Marquette": {
        name: "Marquette",
        logo_id: "269",
    },
    "Marshall": {
        name: "Marshall",
        logo_id: "276",
    },
    "Maryland": {
        name: "Maryland",
        logo_id: "120",
    },
    "Maryland-Eastern Shore": {
        name: "Maryland-Eastern Shore",
        logo_id: "2379",
    },
    "McNeese": {
        name: "McNeese",
        logo_id: "2377",
    },
    "Memphis": {
        name: "Memphis",
        logo_id: "235",
    },
    "Mercer": {
        name: "Mercer",
        logo_id: "2382",
    },
    "Merrimack": {
        name: "Merrimack",
        logo_id: "2771",
    },
    "Miami": {
        name: "Miami",
        logo_id: "2390",
    },
    "Miami (OH)": {
        name: "Miami (OH)",
        logo_id: "193",
    },
    "Michigan": {
        name: "Michigan",
        logo_id: "130",
    },
    "Michigan State": {
        name: "Michigan State",
        logo_id: "127",
    },
    "Middle Tennessee": {
        name: "Middle Tennessee",
        logo_id: "2393",
    },
    "Milwaukee": {
        name: "Milwaukee",
        logo_id: "270",
    },
    "Minnesota": {
        name: "Minnesota",
        logo_id: "135",
    },
    "Mississippi State": {
        name: "Mississippi State",
        logo_id: "344",
    },
    "Mississippi Valley State": {
        name: "Mississippi Valley State",
        logo_id: "2400",
    },
    "Missouri": {
        name: "Missouri",
        logo_id: "142",
    },
    "Missouri State": {
        name: "Missouri State",
        logo_id: "2623",
    },
    "Monmouth": {
        name: "Monmouth",
        logo_id: "2405",
    },
    "Montana": {
        name: "Montana",
        logo_id: "149",
    },
    "Montana State": {
        name: "Montana State",
        logo_id: "147",
    },
    "Morehead State": {
        name: "Morehead State",
        logo_id: "2413",
    },
    "Morgan State": {
        name: "Morgan State",
        logo_id: "2415",
    },
    "Mount St. Mary's": {
        name: "Mount St. Mary's",
        logo_id: "116",
    },
    "Murray State": {
        name: "Murray State",
        logo_id: "93",
    },
    "NC State": {
        name: "NC State",
        logo_id: "152",
    },
    "NJIT": {
        name: "NJIT",
        logo_id: "2885",
    },
    "Navy": {
        name: "Navy",
        logo_id: "2426",
    },
    "Nebraska": {
        name: "Nebraska",
        logo_id: "158",
    },
    "Nevada": {
        name: "Nevada",
        logo_id: "2440",
    },
    "New Hampshire": {
        name: "New Hampshire",
        logo_id: "160",
    },
    "New Mexico": {
        name: "New Mexico",
        logo_id: "167",
    },
    "New Mexico State": {
        name: "New Mexico State",
        logo_id: "166",
    },
    "New Orleans": {
        name: "New Orleans",
        logo_id: "2443",
    },
    "Niagara": {
        name: "Niagara",
        logo_id: "315",
    },
    "Nicholls": {
        name: "Nicholls",
        logo_id: "2447",
    },
    "Norfolk State": {
        name: "Norfolk State",
        logo_id: "2450",
    },
    "North Alabama": {
        name: "North Alabama",
        logo_id: "2453",
    },
    "North Carolina": {
        name: "North Carolina",
        logo_id: "153",
    },
    "North Carolina A&T": {
        name: "North Carolina A&T",
        logo_id: "2448",
    },
    "North Carolina Central": {
        name: "North Carolina Central",
        logo_id: "2428",
    },
    "North Dakota": {
        name: "North Dakota",
        logo_id: "155",
    },
    "North Dakota State": {
        name: "North Dakota State",
        logo_id: "2449",
    },
    "North Florida": {
        name: "North Florida",
        logo_id: "2454",
    },
    "North Texas": {
        name: "North Texas",
        logo_id: "249",
    },
    "Northeastern": {
        name: "Northeastern",
        logo_id: "111",
    },
    "Northern Arizona": {
        name: "Northern Arizona",
        logo_id: "2464",
    },
    "Northern Colorado": {
        name: "Northern Colorado",
        logo_id: "2458",
    },
    "Northern Illinois": {
        name: "Northern Illinois",
        logo_id: "2459",
    },
    "Northern Iowa": {
        name: "Northern Iowa",
        logo_id: "2460",
    },
    "Northern Kentucky": {
        name: "Northern Kentucky",
        logo_id: "94",
    },
    "Northwestern": {
        name: "Northwestern",
        logo_id: "77",
    },
    "Northwestern State": {
        name: "Northwestern State",
        logo_id: "2466",
    },
    "Notre Dame": {
        name: "Notre Dame",
        logo_id: "87",
    },
    "Oakland": {
        name: "Oakland",
        logo_id: "2473",
    },
    "Ohio": {
        name: "Ohio",
        logo_id: "195",
    },
    "Ohio State": {
        name: "Ohio State",
        logo_id: "194",
    },
    "Oklahoma": {
        name: "Oklahoma",
        logo_id: "201",
    },
    "Oklahoma State": {
        name: "Oklahoma State",
        logo_id: "197",
    },
    "Old Dominion": {
        name: "Old Dominion",
        logo_id: "295",
    },
    "Ole Miss": {
        name: "Ole Miss",
        logo_id: "145",
    },
    "Omaha": {
        name: "Omaha",
        logo_id: "2437",
    },
    "Oral Roberts": {
        name: "Oral Roberts",
        logo_id: "198",
    },
    "Oregon": {
        name: "Oregon",
        logo_id: "2483",
    },
    "Oregon State": {
        name: "Oregon State",
        logo_id: "204",
    },
    "Pacific": {
        name: "Pacific",
        logo_id: "279",
    },
    "Penn State": {
        name: "Penn State",
        logo_id: "213",
    },
    "Pennsylvania": {
        name: "Pennsylvania",
        logo_id: "219",
    },
    "Pepperdine": {
        name: "Pepperdine",
        logo_id: "2492",
    },
    "Pittsburgh": {
        name: "Pittsburgh",
        logo_id: "221",
    },
    "Portland": {
        name: "Portland",
        logo_id: "2501",
    },
    "Portland State": {
        name: "Portland State",
        logo_id: "2502",
    },
    "Prairie View A&M": {
        name: "Prairie View A&M",
        logo_id: "2504",
    },
    "Presbyterian": {
        name: "Presbyterian",
        logo_id: "2506",
    },
    "Princeton": {
        name: "Princeton",
        logo_id: "163",
    },
    "Providence": {
        name: "Providence",
        logo_id: "2507",
    },
    "Purdue": {
        name: "Purdue",
        logo_id: "2509",
    },
    "Purdue Fort Wayne": {
        name: "Purdue Fort Wayne",
        logo_id: "2870",
    },
    "Quinnipiac": {
        name: "Quinnipiac",
        logo_id: "2514",
    },
    "Radford": {
        name: "Radford",
        logo_id: "2515",
    },
    "Rhode Island": {
        name: "Rhode Island",
        logo_id: "227",
    },
    "Rice": {
        name: "Rice",
        logo_id: "242",
    },
    "Richmond": {
        name: "Richmond",
        logo_id: "257",
    },
    "Rider": {
        name: "Rider",
        logo_id: "2520",
    },
    "Robert Morris": {
        name: "Robert Morris",
        logo_id: "2523",
    },
    "Rutgers": {
        name: "Rutgers",
        logo_id: "164",
    },
    "SE Louisiana": {
        name: "SE Louisiana",
        logo_id: "2545",
    },
    "SIU Edwardsville": {
        name: "SIU Edwardsville",
        logo_id: "2565",
    },
    "SMU": {
        name: "SMU",
        logo_id: "2567",
    },
    "Sacramento State": {
        name: "Sacramento State",
        logo_id: "16",
    },
    "Sacred Heart": {
        name: "Sacred Heart",
        logo_id: "2529",
    },
    "Saint Joseph's": {
        name: "Saint Joseph's",
        logo_id: "2603",
    },
    "Saint Louis": {
        name: "Saint Louis",
        logo_id: "139",
    },
    "Saint Mary's": {
        name: "Saint Mary's",
        logo_id: "2608",
    },
    "Saint Peter's": {
        name: "Saint Peter's",
        logo_id: "2612",
    },
    "Sam Houston": {
        name: "Sam Houston",
        logo_id: "2534",
    },
    "Samford": {
        name: "Samford",
        logo_id: "2535",
    },
    "San Diego": {
        name: "San Diego",
        logo_id: "301",
    },
    "San Diego State": {
        name: "San Diego State",
        logo_id: "21",
    },
    "San Francisco": {
        name: "San Francisco",
        logo_id: "2539",
    },
    "San José State": {
        name: "San José State",
        logo_id: "23",
    },
    "Santa Clara": {
        name: "Santa Clara",
        logo_id: "2541",
    },
    "Seattle U": {
        name: "Seattle U",
        logo_id: "2547",
    },
    "Seton Hall": {
        name: "Seton Hall",
        logo_id: "2550",
    },
    "Siena": {
        name: "Siena",
        logo_id: "2561",
    },
    "South Alabama": {
        name: "South Alabama",
        logo_id: "6",
    },
    "South Carolina": {
        name: "South Carolina",
        logo_id: "2579",
    },
    "South Carolina State": {
        name: "South Carolina State",
        logo_id: "2569",
    },
    "South Carolina Upstate": {
        name: "South Carolina Upstate",
        logo_id: "2908",
    },
    "South Dakota": {
        name: "South Dakota",
        logo_id: "233",
    },
    "South Dakota State": {
        name: "South Dakota State",
        logo_id: "2571",
    },
    "South Florida": {
        name: "South Florida",
        logo_id: "58",
    },
    "Southeast Missouri State": {
        name: "Southeast Missouri State",
        logo_id: "2546",
    },
    "Southern": {
        name: "Southern",
        logo_id: "2582",
    },
    "Southern Illinois": {
        name: "Southern Illinois",
        logo_id: "79",
    },
    "Southern Miss": {
        name: "Southern Miss",
        logo_id: "2572",
    },
    "Southern Utah": {
        name: "Southern Utah",
        logo_id: "253",
    },
    "St. Bonaventure": {
        name: "St. Bonaventure",
        logo_id: "179",
    },
    "St. Francis (BKN)": {
        name: "St. Francis (BKN)",
        logo_id: "2597",
    },
    "St. Francis (PA)": {
        name: "St. Francis (PA)",
        logo_id: "2598",
    },
    "St. John's": {
        name: "St. John's",
        logo_id: "2599",
    },
    "St. Thomas - Minnesota": {
        name: "St. Thomas - Minnesota",
        logo_id: "2900",
    },
    "Stanford": {
        name: "Stanford",
        logo_id: "24",
    },
    "Stephen F. Austin": {
        name: "Stephen F. Austin",
        logo_id: "2617",
    },
    "Stetson": {
        name: "Stetson",
        logo_id: "56",
    },
    "Stony Brook": {
        name: "Stony Brook",
        logo_id: "2619",
    },
    "Syracuse": {
        name: "Syracuse",
        logo_id: "183",
    },
    "TCU": {
        name: "TCU",
        logo_id: "2628",
    },
    "Tarleton": {
        name: "Tarleton",
        logo_id: "2627",
    },
    "Temple": {
        name: "Temple",
        logo_id: "218",
    },
    "Tennessee": {
        name: "Tennessee",
        logo_id: "2633",
    },
    "Tennessee State": {
        name: "Tennessee State",
        logo_id: "2634",
    },
    "Tennessee Tech": {
        name: "Tennessee Tech",
        logo_id: "2635",
    },
    "Texas": {
        name: "Texas",
        logo_id: "251",
    },
    "Texas A&M": {
        name: "Texas A&M",
        logo_id: "245",
    },
    "Texas A&M-CC": {
        name: "Texas A&M-CC",
        logo_id: "357",
    },
    "Texas Southern": {
        name: "Texas Southern",
        logo_id: "2640",
    },
    "Texas State": {
        name: "Texas State",
        logo_id: "326",
    },
    "Texas Tech": {
        name: "Texas Tech",
        logo_id: "2641",
    },
    "The Citadel": {
        name: "The Citadel",
        logo_id: "2643",
    },
    "Toledo": {
        name: "Toledo",
        logo_id: "2649",
    },
    "Towson": {
        name: "Towson",
        logo_id: "119",
    },
    "Troy": {
        name: "Troy",
        logo_id: "2653",
    },
    "Tulane": {
        name: "Tulane",
        logo_id: "2655",
    },
    "Tulsa": {
        name: "Tulsa",
        logo_id: "202",
    },
    "UAB": {
        name: "UAB",
        logo_id: "5",
    },
    "UC Davis": {
        name: "UC Davis",
        logo_id: "302",
    },
    "UC Irvine": {
        name: "UC Irvine",
        logo_id: "300",
    },
    "UC Riverside": {
        name: "UC Riverside",
        logo_id: "27",
    },
    "UC San Diego": {
        name: "UC San Diego",
        logo_id: "28",
    },
    "UC Santa Barbara": {
        name: "UC Santa Barbara",
        logo_id: "2540",
    },
    "UCF": {
        name: "UCF",
        logo_id: "2116",
    },
    "UCLA": {
        name: "UCLA",
        logo_id: "26",
    },
    "UConn": {
        name: "UConn",
        logo_id: "41",
    },
    "UIC": {
        name: "UIC",
        logo_id: "82",
    },
    "UL Monroe": {
        name: "UL Monroe",
        logo_id: "2433",
    },
    "UMBC": {
        name: "UMBC",
        logo_id: "2378",
    },
    "UMass": {
        name: "UMass",
        logo_id: "113",
    },
    "UMass Lowell": {
        name: "UMass Lowell",
        logo_id: "2349",
    },
    "UNC Asheville": {
        name: "UNC Asheville",
        logo_id: "2427",
    },
    "UNC Greensboro": {
        name: "UNC Greensboro",
        logo_id: "2430",
    },
    "UNC Wilmington": {
        name: "UNC Wilmington",
        logo_id: "350",
    },
    "UNLV": {
        name: "UNLV",
        logo_id: "2439",
    },
    "USC": {
        name: "USC",
        logo_id: "30",
    },
    "UT Arlington": {
        name: "UT Arlington",
        logo_id: "250",
    },
    "UT Martin": {
        name: "UT Martin",
        logo_id: "2630",
    },
    "UT Rio Grande Valley": {
        name: "UT Rio Grande Valley",
        logo_id: "292",
    },
    "UTEP": {
        name: "UTEP",
        logo_id: "2638",
    },
    "UTSA": {
        name: "UTSA",
        logo_id: "2636",
    },
    "Utah": {
        name: "Utah",
        logo_id: "254",
    },
    "Utah State": {
        name: "Utah State",
        logo_id: "328",
    },
    "Utah Valley": {
        name: "Utah Valley",
        logo_id: "3084",
    },
    "VCU": {
        name: "VCU",
        logo_id: "2670",
    },
    "VMI": {
        name: "VMI",
        logo_id: "2678",
    },
    "Valparaiso": {
        name: "Valparaiso",
        logo_id: "2674",
    },
    "Vanderbilt": {
        name: "Vanderbilt",
        logo_id: "238",
    },
    "Vermont": {
        name: "Vermont",
        logo_id: "261",
    },
    "Villanova": {
        name: "Villanova",
        logo_id: "222",
    },
    "Virginia": {
        name: "Virginia",
        logo_id: "258",
    },
    "Virginia Tech": {
        name: "Virginia Tech",
        logo_id: "259",
    },
    "Wagner": {
        name: "Wagner",
        logo_id: "2681",
    },
    "Wake Forest": {
        name: "Wake Forest",
        logo_id: "154",
    },
    "Washington": {
        name: "Washington",
        logo_id: "264",
    },
    "Washington State": {
        name: "Washington State",
        logo_id: "265",
    },
    "Weber State": {
        name: "Weber State",
        logo_id: "2692",
    },
    "West Virginia": {
        name: "West Virginia",
        logo_id: "277",
    },
    "Western Carolina": {
        name: "Western Carolina",
        logo_id: "2717",
    },
    "Western Illinois": {
        name: "Western Illinois",
        logo_id: "2710",
    },
    "Western Kentucky": {
        name: "Western Kentucky",
        logo_id: "98",
    },
    "Western Michigan": {
        name: "Western Michigan",
        logo_id: "2711",
    },
    "Wichita State": {
        name: "Wichita State",
        logo_id: "2724",
    },
    "William & Mary": {
        name: "William & Mary",
        logo_id: "2729",
    },
    "Winthrop": {
        name: "Winthrop",
        logo_id: "2737",
    },
    "Wisconsin": {
        name: "Wisconsin",
        logo_id: "275",
    },
    "Wofford": {
        name: "Wofford",
        logo_id: "2747",
    },
    "Wright State": {
        name: "Wright State",
        logo_id: "2750",
    },
    "Wyoming": {
        name: "Wyoming",
        logo_id: "2751",
    },
    "Xavier": {
        name: "Xavier",
        logo_id: "2752",
    },
    "Yale": {
        name: "Yale",
        logo_id: "43",
    },
    "Youngstown State": {
        name: "Youngstown State",
        logo_id: "2754",
    },
};
